import type { SoundVoice } from "./contracts";
import { VoiceCatalogToggleDialog } from "./VoiceCatalogToggleDialog";

type DisableVoiceDialogProps = {
  environment: "staging" | "stg";
  voice: SoundVoice;
};

export function DisableVoiceDialog({
  environment,
  voice,
}: DisableVoiceDialogProps) {
  return (
    <VoiceCatalogToggleDialog
      environment={environment}
      mode="disable"
      voice={voice}
    />
  );
}
